// FYPN (PLM) agreement HTML is a fragment whose scripts build the
// SignatureDataJson via jQuery. We don't run their scripts at all: this module
// strips them and renders the document read-only with our CSS, and
// FypnContract reconstructs the same JSON from the document's live state.
const SCRIPT_TAG = /<script\b[\s\S]*?<\/script\s*>/gi;

const DOCUMENT_CSS = `
  body {
    margin: 0;
    padding: 16px 20px 28px;
    background: #fff;
    color: #1d2733;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: 13.5px;
    line-height: 1.5;
  }
  div, p, td, span, small, li, b, strong, u, h1, h2, h3 {
    font-family: inherit !important;
  }
  table {
    width: 100%;
  }
  /* The customer types their name once in our panel; the document's signature
     fields are filled from it and shown as an applied signature on a line —
     not a second box to type into. */
  input.signature, input[class^="signature_"], input.initials {
    border: none;
    border-bottom: 1.5px solid #2f80ed;
    background: transparent;
    color: #14315e;
    font-family: "Segoe Script", "Bradley Hand", cursive !important;
    font-size: 19px !important;
    min-width: 220px;
    padding: 2px 4px;
    pointer-events: none;
  }
  input[type="checkbox"], input[type="radio"] {
    width: 18px;
    height: 18px;
    transform: scale(1.25);
    margin: 0 8px;
    accent-color: #2f80ed;
    cursor: pointer;
    vertical-align: middle;
  }
  /* the field the "Next field" guide is pointing at */
  .fypn-focus {
    outline: 3px solid #f5a623 !important;
    outline-offset: 3px;
    border-radius: 2px;
    animation: fypnFocusPulse 1s ease-out 2;
  }
  @keyframes fypnFocusPulse {
    0% { box-shadow: 0 0 0 0 rgba(245, 166, 35, 0.55); }
    70% { box-shadow: 0 0 0 12px rgba(245, 166, 35, 0); }
    100% { box-shadow: 0 0 0 0 rgba(245, 166, 35, 0); }
  }
`;

export default function wrapAgreementHtml(fragment) {
  const body = (fragment || "").replace(SCRIPT_TAG, "");
  return [
    '<!DOCTYPE html><html><head><meta charset="utf-8"/>',
    "<style>" + DOCUMENT_CSS + "</style>",
    "</head><body>",
    body,
    "</body></html>",
  ].join("");
}
